import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/RebatesPage/RebatesPage.tsx");
